import prepaidCardImageQueries from '@apis/queries/prepaidCardImageQueries';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function usePrepaidCardImages() {
    const { t } = useTranslation('prepaidCard');
    const { data, status } = useQuery(prepaidCardImageQueries.list());
    const { pop } = useFlow();
    const images = data?.categories;
    const isLoading = status === 'pending';
    const isBlank = !isLoading && (!images || images.length === 0);
    useEffect(() => {
        if (status === 'error') {
            pop();
            toast.error(t('images.error'));
        }
    }, [status]);
    return { images, isLoading, isBlank };
}

export default usePrepaidCardImages;
